
export interface Discipline_POST_PUT {
    name: string;
    description: string;
    signupCostInSek: number;
    displayOrder: number;

    minAge: number | null;
    maxAge: number | null;
    groupSize: number | null;
    signupOpenTime: number | null;
    signupClosedTime: number | null;
    deleted: boolean;
    startNumberSequences: Array<StartNumberSequence>;
    genderRequirements: Array<Gender>; // What genders are required to select from for this signup
    distanceInMeters: number;
    resultType: ResultType;
}


export enum Gender {
    MAN = "MAN",
    WOMAN = "WOMAN"
}

export enum ResultType {
    INDIVIDUAL = "INDIVIDUAL",
    GROUP = "GROUP"
}



export interface StartNumberSequence {
    firstStartNumber: number;
    lastStartNumber: number;
}
